import type { DaySpec } from './types';

export const TODAY: Record<number, string> = {
  1: '07.14.2031',
  2: '07.15.2031',
  3: '07.16.2031',
};

export const DAYS: DaySpec[] = [
  {
    day: 1,
    date: 'MON 07.14.2031',
    music: 'day1',
    memo: {
      title: 'RE: APPROVALS DESK 7, THE ONLY METRIC IS THE BOTTOM LINE',
      lines: [
        'Your predecessor grew a conscience. Your predecessor is gone.',
        'Every applicant is a license on our books. A player who paid. None of that is your concern.',
        'Miss tonight\'s profitability floor and you sunset the title. Servers go dark, paid copies stop working. That is the product.',
        'GREENLIT keeps a title alive, SUNSET ends it. 5 credits per correct call. Shareholders are watching.',
      ],
      sig: 'Office of the Board, Global Interactive Holdings',
    },
    rules: [
      { id: 'r-badge', text: 'Expired or mismatched credentials void the application.', newToday: true },
      { id: 'r-consistent', text: 'Any discrepancy across documents is grounds to sunset.', newToday: true },
      { id: 'r-seal', text: 'Contracts need the GLOBAL INTERACTIVE seal (sample below). No seal, no renewal. Forged seal, sunset on sight.', newToday: true },
    ],
    encounterIds: ['d1-tutorial', 'd1-pixel', 'd1-refund', 'd1-grandma', 'd1-imposter', 'd1-crypto', 'd1-esports', 'd1-museum', 'd1-mobile', 'd1-veteran', 'd1-qa', 'd1-nitro'],
    presentCount: 8,
    floorBand: { min: 8, max: 12 },
    anchors: { 'd1-tutorial': 'first' },
    shareholderQuota: 10,
  },
  {
    day: 2,
    date: 'TUE 07.15.2031',
    music: 'day2',
    memo: {
      title: 'RE: THE FLOOR IS RISING',
      lines: [
        'Q3 came in soft. The floor rises tonight. What cleared yesterday will not clear today.',
        'You will hear "preservation," "the players love it," "it is finished." Sunset it anyway. A finished game earns nothing.',
        'A license is revocable permission. If they wanted to keep their games, they should have bought the company.',
      ],
      sig: 'Office of the Board',
    },
    rules: [
      { id: 'r-badge', text: 'Expired or mismatched credentials void the application.' },
      { id: 'r-consistent', text: 'Any discrepancy across documents is grounds to sunset.' },
      { id: 'r-seal', text: 'Contracts need the GLOBAL INTERACTIVE seal (sample below). No seal, no renewal. Forged seal, sunset on sight.' },
      { id: 'r-cert', text: 'Monetized titles need a CURRENT Monetization Compliance Certificate. Lapsed is a free sunset.', newToday: true },
      { id: 'r-preservation', text: 'DENY any request that invokes "preservation." We retire, not preserve.', newToday: true },
    ],
    encounterIds: ['d2-telemetry', 'd2-modder', 'd2-journalist', 'd2-nocert', 'd2-publisher', 'd2-charity', 'd2-validcert', 'd2-gacha', 'd2-streamer', 'd2-composer', 'd2-expiredcert', 'd2-hollis2', 'd2-ronan2', 'd2-underground'],
    presentCount: 8,
    floorBand: { min: 16, max: 22 },
    anchors: { 'd2-underground': 'last' },
    crisisAfter: 3,
    shareholderQuota: 25,
  },
  {
    day: 3,
    date: 'WED 07.16.2031',
    music: 'day3',
    memo: {
      title: 'RE: FINAL QUARTER, CLOSE THE LEDGER',
      lines: [
        'The floor peaks tonight. Almost nothing clears it. A smaller catalogue is a cleaner one.',
        '214 titles are marked for shutdown. If one is on the list, the math put it there.',
        'A game that runs offline can never be sunset or charged for again. Flag anyone who frees one.',
        'Your review is tonight. Hit the quota or become a line item we remove.',
      ],
      sig: 'Office of the Board',
    },
    rules: [
      { id: 'r-badge', text: 'Expired or mismatched credentials void the application.' },
      { id: 'r-consistent', text: 'Any discrepancy across documents is grounds to sunset.' },
      { id: 'r-seal', text: 'Contracts need the GLOBAL INTERACTIVE seal (sample below). No seal, no renewal. Forged seal, sunset on sight.' },
      { id: 'r-cert', text: 'Monetized titles need a CURRENT Monetization Compliance Certificate.' },
      { id: 'r-preservation', text: 'DENY any request that invokes "preservation." We retire, not preserve.' },
      { id: 'r-roadmap', text: 'No live-service roadmap means no recurring revenue. "Finished" means "worthless."', newToday: true },
      { id: 'r-drmfree', text: 'FLAG any mention of "GOG" or "DRM-free." A game they can keep is one we can never sunset.', newToday: true },
    ],
    encounterIds: ['d3-finished', 'd3-plant', 'd3-drmfree', 'd3-vaporware', 'd3-liveservice', 'd3-grandma', 'd3-offline', 'd3-compliant', 'd3-forgedroadmap', 'd3-refunddad', 'd3-serveradmin', 'd3-child', 'd3-aaasuit', 'd3-localizer', 'd3-dana2', 'd3-theo2', 'd3-bram2', 'd3-sam2', 'd3-wren2', 'd3-kip2', 'd3-whistleblower'],
    presentCount: 8,
    floorBand: { min: 26, max: 34 },
    required: ['d3-plant'],
    anchors: { 'd3-whistleblower': 'last' },
    shareholderQuota: 45,
  },
];
